import { xy2exprOLD } from "../core/alphabet";
import _cell from '../core/cell';

export function getSelectionStats(data, table) {
    const { sri, sci, eri, eci } = data?.selector?.range;
    const start = xy2exprOLD(sci, sri); // e.g. A1
    const end = xy2exprOLD(eci, eri);   // e.g. B3
    const formulaParser = table.formulaParser;
    let count = 0;
    for (let ri = sri; ri <= eri; ri++) {
        for (let ci = sci; ci <= eci; ci++) {
            const cell = data.getCell(ri, ci);
            const cellData = cell ? cell.text : null;
            if (cellData) {
                count++;
            }
        }
    }
    // Helper to build and evaluate fake formula
    const evalStat = (fnName) => {
        const formula = `=${fnName}(${start}:${end})`;
        const result = _cell.render(
            formula,
            formulaParser,
            (y, x) => data.getCellTextOrDefault(x, y),
            data.allSheets
        );
        return result;
    };

    const sum = evalStat("SUM");
    const avg = evalStat("AVERAGE")
    return {
        sum,
        avg,
        count
    };
}
